import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useToast } from '../context/ToastContext'
import { agreementsApi } from '../api/agreements'

const AGREEMENT_TYPES = ['privacy', 'terms', 'subscription']
const AGREEMENT_SUBTYPES = ['', 'no_refund', 'email_valid']

export default function CreateAgreement() {
    const navigate = useNavigate()
    const { addToast } = useToast()

    const [type, setType] = React.useState('terms')
    const [subtype, setSubtype] = React.useState('')
    const [effectiveDate, setEffectiveDate] = React.useState('')
    const [content, setContent] = React.useState('')
    const [requiresReacknowledgment, setRequiresReacknowledgment] = React.useState(true)
    const [loading, setLoading] = React.useState(false)

    async function handleSubmit(e) {
        e.preventDefault()
        setLoading(true)
        try {
            await agreementsApi.create({
                type,
                subtype: subtype || null,
                effective_date: effectiveDate,
                content,
                requires_reacknowledgment: requiresReacknowledgment,
            })
            addToast('Agreement created', 'success')
            navigate('/lobby')
        } catch (err) {
            addToast(err.message, 'error')
        } finally {
            setLoading(false)
        }
    }

    const inputClass = "px-3 py-2 border border-gray-300 rounded-md font-karla text-base outline-none focus:border-bankroll-primary"
    const labelClass = "flex flex-col gap-1.5 font-semibold text-sm text-bankroll-text"
    const selectClass = `${inputClass} bg-white`

    return (
        <main className="flex w-full flex-col items-center justify-start px-5 py-6">
            <div className="bg-white rounded-xl w-full max-w-lg shadow-lg overflow-hidden">
                <div className="px-9 py-4">
                    <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
                        <label className={labelClass}>
                            Type
                            <select className={selectClass} value={type} onChange={e => setType(e.target.value)}>
                                {AGREEMENT_TYPES.map(t => (
                                    <option key={t} value={t}>{t}</option>
                                ))}
                            </select>
                        </label>

                        <label className={labelClass}>
                            Subtype
                            <select className={selectClass} value={subtype} onChange={e => setSubtype(e.target.value)}>
                                <option value="">— none —</option>
                                {AGREEMENT_SUBTYPES.filter(s => s).map(s => (
                                    <option key={s} value={s}>{s}</option>
                                ))}
                            </select>
                        </label>

                        <label className={labelClass}>
                            Effective Date
                            <input
                                className={inputClass}
                                type="date"
                                value={effectiveDate}
                                onChange={e => setEffectiveDate(e.target.value)}
                                required
                            />
                        </label>

                        <label className={labelClass}>
                            Content
                            <textarea
                                className={`${inputClass} resize-y min-h-[200px]`}
                                value={content}
                                onChange={e => setContent(e.target.value)}
                                required
                            />
                        </label>

                        <label className="flex items-center gap-2 font-karla text-sm text-bankroll-text cursor-pointer">
                            <input
                                type="checkbox"
                                checked={requiresReacknowledgment}
                                onChange={e => setRequiresReacknowledgment(e.target.checked)}
                            />
                            Requires re-acknowledgment
                        </label>

                        <button
                            type="submit"
                            disabled={loading}
                            className="mt-2 py-2.5 px-6 bg-bankroll-primary text-white font-karla font-semibold rounded-md hover:opacity-90 disabled:opacity-50"
                        >
                            {loading ? 'Saving…' : 'Create Agreement'}
                        </button>
                    </form>
                </div>
            </div>
        </main>
    )
}
